import React from 'react';
import { useTranslation } from 'react-i18next';
import { Settings } from 'lucide-react';
import BrandSettings from '../../components/admin/BrandSettings';

const AdminSettings = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1f2937] to-[#111827] p-4 md:p-6">
      <div className="max-w-6xl mx-auto">
        {/* Page Header */}
        <div className="flex items-center gap-3 mb-8">
          <div className="p-2 bg-[#a15507] rounded-lg">
            <Settings className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-white mb-1">
              {t('admin.settings')}
            </h1>
            <p className="text-gray-400 text-sm md:text-base">
              Manage system-wide settings and configurations
            </p>
          </div>
        </div>

        {/* Settings Grid */}
        <div className="grid gap-6 lg:gap-8">
          {/* Brand Settings Section */}
          <div className="space-y-4">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-1 w-8 bg-[#a15507] rounded"></div>
              <h2 className="text-lg font-semibold text-gray-300">{t('admin.brandSettings.title')}</h2>
            </div>
            <BrandSettings />
          </div>

          {/* Future Settings Sections can be added here */}
          {/* 
          <div className="space-y-4">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-1 w-8 bg-[#a15507] rounded"></div>
              <h2 className="text-lg font-semibold text-gray-300">System Configuration</h2>
            </div>
            Add more settings components here
          </div>
          */}
        </div>

        {/* Footer */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm">
            Changes made here will affect the entire application
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
